// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"Login_rectangle__2IiEg","login_btn":"Login_login_btn__37yH9","form_block":"Login_form_block__3utcM"};